module.exports = __webpack_public_path__ + "static/bootstrap-button-single-toggle-8b75b9feb8029fe598c5487a3f155826.gif";